/** IXD vs Workbook 구조 비교 mutation 훅 */

import { useMutation } from "@tanstack/react-query";
import { isInvalidIxdStructureError } from "@/apis/errors";
import { compareIxdWithWorkbook } from "@/apis/ixd-workbook-compare/route";
import { UploadFailedModal } from "@/components/modals/upload-failed-modal";
import { pushModal } from "@/stores/modal";
import { useIxdWorkbookCompareStore } from "@/stores/ixd-workbook-compare";

interface UseIxdWorkbookCompareParams {
  ixdFile: File | null;
  selectedWorkbookId: string | null;
}

export const useIxdWorkbookCompare = ({
  ixdFile,
  selectedWorkbookId,
}: UseIxdWorkbookCompareParams) => {
  const setResult = useIxdWorkbookCompareStore((s) => s.setResult);

  const mutation = useMutation({
    mutationFn: () => {
      if (!ixdFile || !selectedWorkbookId) {
        return Promise.reject(new Error("IXD 파일과 workbook을 선택해주세요."));
      }
      return compareIxdWithWorkbook(selectedWorkbookId, ixdFile);
    },
    onSuccess: (data) => {
      setResult(data);
    },
    onError: (error) => {
      if (isInvalidIxdStructureError(error)) {
        pushModal(UploadFailedModal);
      }
    },
  });

  const canCompare = !!ixdFile && !!selectedWorkbookId;

  const handleCompare = () => {
    if (!canCompare) return;
    mutation.mutate();
  };

  return {
    isComparing: mutation.isPending,
    handleCompare,
    canCompare,
    error: isInvalidIxdStructureError(mutation.error)
      ? null
      : mutation.error,
  };
};
